<!-- 안전리더십 > 컨텐츠수행 > 모니터링형식 -->
<template>
  <div class="nodata-group" v-if="!isActiveMonitoring">
    <div class="txt">{{t('message.monitoringEnded')}}</div>
  </div>
  <div class="list-group2 ty01 mg-none" v-if="isActiveMonitoring" :class="{ 'disabled-block': isEndMonitoring }">
    <!--list-->
    <div class="list" v-for="(item, i) in monitoringItems" :key="i">
      <div class="row1">
        <div class="num">{{i+1}}</div>
        <div class="txt">{{item.behaviorTitle}}</div>
      </div>
      <div class="row2">
        <!-- 카운트 -->
        <div class="radio-group2" v-if="item.behaviorType == '1'">
          <div class="row2-inner">
            <div class="inner-col">
              {{t('message.safeLS')}}
              <InputCount v-model="item.answerData"/>
            </div>
            <div class="inner-col">
              {{t('message.unsafeLS')}}
              <InputCount v-model="item.answerData2"/>
            </div>
          </div>
        </div>
        <!-- 선택형 -->
        <div class="radio-group2" v-if="item.behaviorType == '2'">
          <v-radio-group v-model="item.answerData" :disabled="item.etcYn=='Y'">
            <v-radio :label="t('message.safeLS')" value="1"></v-radio>
            <v-radio :label="t('message.unsafeLS')" value="0"></v-radio>
          </v-radio-group>
        </div>
        <!-- 리커트, 바 -->
        <div class="radio-group2" v-if="item.behaviorType == '3' || item.behaviorType == '4'">
          <v-radio-group v-model="item.answerData">
            <v-radio v-for="(item2, i2 ) in item.behaviorComments"
                     :key="i2"
                     :label="`${item2.commentTitle} ${item2.commentContent}`"
                     :value="(i2+1)+''"
                     @click="item.answerData = item.answerData === item2.answerData ? null : item2.answerData"
                     :disabled="item.etcYn=='Y'"></v-radio>
          </v-radio-group>
        </div>
        <!-- 다중선택 -->
        <div class="radio-group2" v-if="item.behaviorType == '5'">
          <div class="check-group2">
            <v-checkbox v-for="(item2, i2 ) in item.behaviorComments"
                        v-model="item.answerData"
                        :key="i2"
                        :value="(i2+1)+''"
                        :label="`${item2.commentTitle}`">
            </v-checkbox>
          </div>
        </div>
        <!-- 기타형 -->
        <div class="radio-group2" v-if="item.behaviorType == '6'">
          <c-input :placeholder="t('message.enterAdditionalComments')" v-model="item.comment" :name="`comment${i}`"></c-input>
        </div>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import {useCommonStore} from "@/store/common";
import utils from "@/common/Utils";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import PdfEmbed from 'vue-pdf-embed';
import LeadershipService from "@/services/leadership.service";
import axios from "axios";
import dayjs from "dayjs";
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps(['item', 'isActive'])
const emit = defineEmits(['complete', 'save'])

//bind
const snackbar = ref(false)
const snackText = ref('')
const contentInfo:any = ref({})
const monitoringData:any = ref({})
const monitoringItems:any = ref([])
const isActiveMonitoring = ref(true)
const isEndMonitoring = ref(false)

//function
const getMonitoring=async()=>{
  try{
    monitoringData.value = {}
    contentInfo.value = props.item
    const companyIdx = localStorage.getItem('companyIdx')
    let params = {
      companyIdx: companyIdx,
      contentIdx: contentInfo.value.idx,
      memberIdx: contentInfo.value.memberIdx,
      targetMemberIdx: contentInfo.value.targetMemberIdx  // 타인관찰 시 조건
    }
    const response = await LeadershipService.getMonitoring(params)
    if (response.success) {
      //데이터
      monitoringData.value = response.result
      //모니터링 진행여부 확인
      const now = dayjs()
      isActiveMonitoring.value = now.isAfter(dayjs(monitoringData.value.startDate)) && now.isBefore(dayjs(monitoringData.value.endDate))
      //행동
      let monitoringItemArr = []
      let behaviorArr = {items:[{name:t('message.notSelected'), value:''}]}
      _.forEach(response.result.behaviorList, (item, key)=> {
        item.answerData = 0
        if(item.behaviorType == '5')  //다중선택
          item.answerData = []
        if(item.behaviorType != '1' && item.behaviorType != '2' && item.behaviorType != '6')  //아이템갯수셋팅
          item.answerData2 = item.behaviorComments.length
        monitoringItemArr.push(item)
        let tempBehavior = {name:item.behaviorTitle, value:item.idx}
        behaviorArr.items.push(tempBehavior)
      })
      monitoringItems.value = monitoringItemArr
    } else{
      snackText.value = response.message
      snackbar.value = true
    }

    //응답처리
    if(!utils.isEmpty(monitoringData.value.answerList) && monitoringData.value.answerList?.length > 0) {
      if(monitoringData.value.answerList.length >= contentInfo.value.periodCnt) {
        emit('complete', true)
        isEndMonitoring.value = true
        _.forEach(monitoringData.value.behaviorList, (val, key) => {
          _.forEach(monitoringData.value.answerList, (val2, key2) => {
            _.forEach(val2.answers, (val3, key3) => {
              if (val3.behaviorIdx == val.idx) {
                if (val3.behaviorType != '5')
                  val.answerData = val3.answerData
                else
                  val.answerData = val3.answerData?.split(',') || []
                val.answerData2 = val3.answerData2
                val.comment = val3.comment
              }
            })
          })
        })
      }
    }
    else {
      emit('complete', false)
      isEndMonitoring.value = false
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const childRefSave=async()=>{
  const allAnswered = _.every(monitoringData.value.behaviorList, item => item.essentialYn !== 'Y' || (item.behaviorType === '1' || item.behaviorType === '6' || (!_.isNil(item.answerData) && item.answerData !== 0)))
  if(!allAnswered){
    snackText.value = t('message.selectAllRequired')
    snackbar.value = true
    return
  }

  try {
    let answers = []
    _.forEach(monitoringData.value.behaviorList, (item, key)=> {
      let tempObj = {}
      tempObj['behaviorIdx'] = item.idx
      tempObj['behaviorType'] = item.behaviorType
      if(item.behaviorType == '5')
        tempObj['answerData'] = item.answerData.join(',')
      else
        tempObj['answerData'] = item.answerData
      tempObj['answerData2'] = item.answerData2
      tempObj['comment'] = item.comment
      answers.push(tempObj)
    })

    const user = JSON.parse(localStorage.getItem('user'))
    const companyIdx = localStorage.getItem('companyIdx')
    let params = {
      monitoringIdx: monitoringData.value.idx,  //리더십 모니터링
      periodSeq: monitoringData.value.periodSeq,
      companyIdx: companyIdx?companyIdx:user.companyIdx,
      answers: answers,
      memberIdx: monitoringData.value.memberIdx,
      targetMemberIdx: monitoringData.value.targetMemberIdx,
      leadershipIdx: contentInfo.value.leadershipIdx,
      taskIdx: contentInfo.value.taskIdx,
      contentIdx: contentInfo.value.idx,
      contentType: contentInfo.value.contentType,
    }

    const response = await LeadershipService.insertMonitoringAnswer(params)
    if (response.success){
      snackText.value = t('message.submissionCompleted')
      snackbar.value = true
      emit('complete', true)
      isEndMonitoring.value = true

      //완료여부 부모로 전송. 부모창에서 알아서 닫기
      emit('save', true)
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onInputEtc=(value, index)=>{
  if(value) {
    monitoringItems.value[index].comment = null
  }
}

//watch
watch(() => props.isActive, (val, oldVal) => {
  if (val)
    getMonitoring()
},{ immediate: true })

//expose
defineExpose({
  childRefSave,
})
</script>


<style lang="scss" scoped>
</style>
